module.exports = __webpack_public_path__ + "static/chambers-752f1ba8d5a23792673baf96693541fe.png";